// Section component for controlling max-width of content and centering
import styled from 'styled-components'
import device from '../../utilities/device'

type ContentContainerProps = {
  verticalPadding?: string
}

const ContentContainer = styled.div<ContentContainerProps>`
  max-width: 1500px;
  margin: 0 auto;
  padding: 70px 50px;
  ${props => props.verticalPadding && `padding: ${props.verticalPadding} 50px;`}
  @media ${device.laptop} {
    padding: 30px;
    ${props =>
      props.verticalPadding && `padding: ${props.verticalPadding} 30px;`}
  }
`

export default ContentContainer
